import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import {
  GetProjectDemoListQuery,
  GetProjectDemoListResponse,
  ProjectDemoModel,
  ProjectSourceInfoModel,
  GetProjectDemoPushLogListResponse,
} from './type'
import { AxiosPromise } from 'axios'

// 获取列表
export function getProjectDemoList(
  params: GetProjectDemoListQuery,
): AxiosPromise<{ data: GetProjectDemoListResponse }> {
  return request({
    url: `${v2Host}/demo/project/list`,
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 新增demo项目
export function addProjectDemo(
  params: ProjectSourceInfoModel & { name: ProjectDemoModel['name'] },
): AxiosPromise {
  return request({
    url: `${v2Host}/demo/project/save`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

// 删除demo项目
export function deleteProjectDemo(params: {
  id: ProjectDemoModel['id']
}): AxiosPromise {
  return request({
    url: `${v2Host}/demo/project/delete`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

// 推送demo项目
export function pushProjectDemo(params: {
  id: ProjectDemoModel['id']
  adv_name: ProjectDemoModel['src_adv_name'] // 用户输入的
  name: ProjectDemoModel['name']
  type: ProjectDemoModel['type']
}): AxiosPromise {
  return request({
    url: `${v2Host}/demo/project/push`,
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

// 获取项目源信息
export function getProjectDemoSourceInfo(params: {
  id: any
  type: ProjectDemoModel['type']
}): AxiosPromise<{ data: ProjectSourceInfoModel | null }> {
  return request({
    url: `${v2Host}/demo/project/src-info`,
    method: 'get',
    params: cookRequestParams({ ...params }),
  })
}

// 获取推送日志
export function getProjectDemoPushLog(params: {
  id: ProjectDemoModel['id']
}): AxiosPromise<{ data: GetProjectDemoPushLogListResponse }> {
  return request({
    url: `${v2Host}/demo/project/push-log`,
    method: 'get',
    params: cookRequestParams(params),
  })
}
